var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursorDefault",attrs:{"id":"app"}},[_c('router-view'),_c('mydetails',{attrs:{"show":_vm.alarmShow,"showData":_vm.alarmData},on:{"update:show":function($event){_vm.alarmShow=$event}}}),_c('audio',{attrs:{"id":"globalAlarmAudio","src":require('@/assets/mp3/jb.mp3'),"loop":""}}),_c('VoipCallNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }